import FileUploaderContainer from './FilesManagerContainer';

export default FileUploaderContainer;
